import styled from "@emotion/styled";
import React, { forwardRef, useEffect, useImperativeHandle } from "react";

const FormContent = forwardRef((props, ref) => {
  const { input, config, layout } = props;

  useImperativeHandle(ref, () => ({
    reset() {},
  }));

  return (
    <StyledFormContent
      config={config}
      className={`input__group ${layout} ${input?.type}-input`}
    >
      {input.content}
    </StyledFormContent>
  );
});

export default FormContent;

const StyledFormContent = styled.div``;
